import { render, staticRenderFns } from "./TipoInstitucionPage.vue?vue&type=template&id=78dca0c6"
import script from "./TipoInstitucionPage.js?vue&type=script&lang=js&external"
export * from "./TipoInstitucionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports